import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const RelationshipEventColumnDataDisplayRecord = Record({
  groupColumnIndex: null,
  referenceId: null,
  label: null,
  icon: null,
  color: null
});

createFromJS.registerCallback(
  "RelationshipEventColumnDataDisplayRecord",
  createFromJS.createPrimitiveCallback(RelationshipEventColumnDataDisplayRecord)
);
